import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-labo-widget',
  templateUrl: './labo-widget.component.html',
  styleUrls: ['./labo-widget.component.scss']
})
export class LaboWidgetComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
